import {AlertModalActionType} from "../../const/actionType";
import {ALERT_VARIANT, PLACEMENT} from "../../const/dataEnum";

const initialState = {
  showAlert: false,
  messageAlert: "",
  typeAlert: ALERT_VARIANT.SUCCESS,
  alertPlace: PLACEMENT.TOP_CENTER,
  delay: null,
};

export default function alertModalStateReducer(state = initialState, action) {
  switch (action.type) {
    case AlertModalActionType.SET_ALERT:
      return {
        ...state,
        showAlert: action.show,
        messageAlert: action.message,
        typeAlert: action.variant,
        delay: action.timeout,
      };
    default:
      return state;
  }
}
